import { FormattedMessage } from 'react-intl';
import React from 'react';

import messages from './messages';

export const NAME = 'manage-properties';
export const TABLE_NAME = 'manage-properties';

export const HEADERS = ({ intl }) => [
  {
    id: 'status',
    label: <FormattedMessage {...messages.status} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
    multiselect: true,
    filterOptions: [],
  },
  {
    id: 'propertyName',
    label: <FormattedMessage {...messages.propertyName} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
  },
  {
    id: 'shortName',
    label: <FormattedMessage {...messages.shortName} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
  },
  {
    id: 'ownerName',
    label: <FormattedMessage {...messages.ownerName} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
    multiselect: true,
    filterOptions: [],
  },
  {
    id: 'propertyType',
    label: <FormattedMessage {...messages.propertyType} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
    multiselect: true,
    filterOptions: [],
  },
  {
    id: 'address',
    label: <FormattedMessage {...messages.address} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
  },
  {
    id: 'phone',
    label: <FormattedMessage {...messages.phone} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
  },
  {
    id: 'email',
    label: <FormattedMessage {...messages.email} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
  },
  {
    id: 'period',
    label: <FormattedMessage {...messages.period} />,
    sortable: true,
    searchable: true,
    dataType: 'date',
    multiselect: true,
    filterOptions: [],
  },
  {
    id: 'autoLateFeesPostingActive',
    label: <FormattedMessage {...messages.autoLateFeesPostingActive} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
    multiselect: true,
    filterOptions: [],
  },
  {
    id: 'leaseVariance',
    label: <FormattedMessage {...messages.leaseVariance} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
    multiselect: true,
    filterOptions: [],
  },
  {
    id: 'gpr',
    label: <FormattedMessage {...messages.gpr} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
    multiselect: true,
    filterOptions: [],
  },
  {
    id: 'portalActive',
    label: <FormattedMessage {...messages.portalActive} />,
    sortable: true,
    searchable: true,
    dataType: 'string',
    multiselect: true,
    filterOptions: [
      { text: 'Yes', value: 'Yes' },
      { text: 'No', value: 'No' },
      { text: 'In Process', value: 'In Process' },
    ],
  },
  {
    id: 'links',
    label: <FormattedMessage {...messages.links} />,
    sortable: false,
    searchable: false,
    dataType: 'links',
  },
];

export const PROPERTY_PATH_MAP = {
  status: {
    path: 'status.value',
    dataType: 'string',
  },
  propertyName: {
    path: 'propertyName.value',
    dataType: 'string',
  },
  shortName: {
    path: 'shortName.value',
    dataType: 'string',
  },
  ownerName: {
    path: 'ownerName.value',
    dataType: 'string',
  },
  propertyType: {
    path: 'propertyType.value',
    dataType: 'string',
  },
  address: {
    path: 'address.value',
    dataType: 'string',
  },
  phone: {
    path: 'phone.value',
    dataType: 'string',
  },
  email: {
    path: 'email.value',
    dataType: 'string',
  },
  period: {
    path: 'period.value',
    dataType: 'string',
  },
  autoLateFeesPostingActive: {
    path: 'autoLateFeesPostingActive.value',
    dataType: 'string',
  },
  leaseVariance: {
    path: 'leaseVariance.value',
    dataType: 'number',
  },
  gpr: {
    path: 'gpr.value',
    dataType: 'string',
  },
  portalActive: {
    path: 'portalActive.value',
    dataType: 'string',
  },
  links: {
    path: 'links.array',
    dataType: 'links',
  },
};
